import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IPurchaseApplication } from 'pages/PagePurchaseApplication/interfaces';

export const getPurchaseApplicationList = (data: IDynamicTableParams) => {
  return instance()
    .post<IPurchaseApplication[]>('/purchase/list', data)
    .then((response) => response.data);
};

export const getPurchaseApplicationAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/purchase/availableColumns')
    .then((response) => response.data);
};

export const getPurchaseApplicationAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/purchase/availableGroupColumns')
    .then((response) => response.data);
};
